import {Col, DatePicker, Form, Input, Modal, Row, Select} from 'antd'
import AddSelect from 'components/AddSelect'
import React, {useState} from 'react'
import styles from './editClientForm.module.less'
import { EmailValidateRule, PhoneRule } from 'utils/ValidateRulesAndMsg'
import { TrimInput, TrimTextArea } from 'components/WithTrim/index'
import commonComponent from 'components/index'
import myMessage from 'components/Message'
import { CustomerTypes } from 'constants/Options'
const { ProvinceSelectCascader } = commonComponent
const { Option } = Select

const EditClientForm = ({
  visible,
  onCreate,
  onCancel,
  clientInfo,
  isAdd,
}) => {
  const [form] = Form.useForm()
  const { TextArea } = Input;
  const client=JSON.parse(JSON.stringify(clientInfo))
  useState(() => {
    form.setFieldsValue({
      customerName: client.customerName?client.customerName:'',
      customerPhone: client.customerPhone?client.customerPhone:'',
      customerWechat: client.customerWechat?client.customerWechat:'',
      customerEmail: client.customerEmail?client.customerEmail:'',
      areaArray: client.customerProvinceGeoId?[client.customerProvinceGeoId,client.customerCityGeoId,client.customerAreaGeoId]:'',
      customerAddress: client.customerAddress?client.customerAddress:'',
      customerRemark: client.customerRemark?client.customerRemark:'',
      customerCompany: client.customerCompany?client.customerCompany:'',
    })
  }, [clientInfo])
  return (
    <Modal
      visible={visible}
      title={isAdd?"添加新客户":'编辑客户'}
      okText={isAdd?"创建":'保存'}
      cancelText="取消"
      centered
      cancelButtonProps={{className: 'footerCanceltext'}}
      onCancel={onCancel}
      maskClosable={false}
      width={700}
      forceRender={true}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            if(!values.customerPhone&&!values.customerEmail){
              myMessage.warning('联系电话或邮箱必须填写一个')
              return
            }
            form.resetFields()
            onCreate(values)
          })
          .catch((info) => {
            console.log('Validate Failed:', info)
          })
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="add_project_form"
        requiredMark={false}
        className={styles.createProjectDialog}
        destroyOnClose={true}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
                name="customerName"
                label="客户名称"
                rules={[
                  {
                    required: true,
                    message: '请输入',
                  },
                ]}
            >
              <Input placeholder="请输入" maxLength={30}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="customerPhone"
              label="电话"
              rules={[PhoneRule]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="customerWechat"
              label="微信"
            >
              <Input placeholder="客户绑定微信后自动添加" disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="customerEmail"
              label="Email"
              rules={[EmailValidateRule]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name=""
              label="客户来源"
            >
              <Select
                  // onChange={value => selectChange(value, item)}
                  // defaultValue="客户来源"
                  // bordered={false}
                  // style={{width: 140}}
                  suffixIcon={
                    <span className="iconfont iconbtn_a_dpdownmenu select-icon"></span>
                  }
              >
                {CustomerTypes.map(item => (
                    <Option value={item.value} key={item.key}>{item.label}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="customerCompany"
              label="公司名称"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name=""
              label="地址"
            >
              <Form.Item
                  label=""
                  name="areaArray"
                  className={styles.Inf_ant_form_item}
              >
                <ProvinceSelectCascader />
              </Form.Item>
              <Form.Item
                  style={{display:'inline-block'}}
                  label=""
                  name="customerAddress"
                  // rules={[RequiredInputRule]}
              >
                <TrimInput style={{width:'309px'}}  placeholder="详细地址"/>
              </Form.Item>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="备注" name='customerRemark'>
              <TextArea rows={3} placeholder=""/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default EditClientForm
